@if (itemAction.userCanPerformAction && !hidden) {
  <raised-button [color]="itemAction.actionColor" (click)="itemAction.action(item)" [ngStyle]="{ margin: '3px' }" id="list-action-{{item.id}}">
    <i [className]="itemAction.actionIconClass"></i> {{ itemAction.actionText }}
  </raised-button>
}
